import { render } from "./SocialLinksPage.vue?vue&type=template&id=52f812a7&ts=true"
import script from "./SocialLinksPage.vue?vue&type=script&lang=ts"
export * from "./SocialLinksPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__